<div class="modal-header">
  <h2 class="modal-title">{{ title }}</h2>
  <button
    type="button"
    class="btn-close"
    aria-label="Close"
    (click)="activeModal.dismiss()"
  ></button>
</div>
<div class="modal-body modal-body__alert">
  @for (type of messages | keys; track type) {
    @if (messages[type].messages.length) {
      <div
        class="modal-body__alert__container"
        >
        <div
        class="modal-body__alert__icon modal-body__alert__icon--{{
          messages[type].type
        }}"
          >
          <span class="fa-exclamation-circle fa-solid"></span>
        </div>
        <div
        class="modal-body__alert__messages modal-body__alert__messages--{{
          messages[type].type
        }}"
          >
          @for (message of messages[type].messages; track message) {
            <p>{{ message }}</p>
          }
        </div>
      </div>
    }
  }

  @if (question !== 'none') {
    <p class="modal-body__alert__question">
      {{ question }}
    </p>
  }

  @if (options.length) {
    <form>
      <div [formGroup]="optionsForm!" class="d-flex flex-column">
        @for (option of options; track option; let i = $index) {
          <button
            type="button"
            class="card btn btn-outline-primary p-0 m-3"
            [dfManageCardSelectable]="(optionsForm?.valueChanges | async)?.selectedOption === option"
            >
            <div class="card-body">
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="radio"
                  id="option_{{ i }}"
                  formControlName="selectedOption"
                  [value]="option"
                  />
                  <label class="form-check-label card-title h3" for="option_{{ i }}">{{ option.title }}</label>
                </div>
                <p class="card-text ms-6">{{ option.description }}</p>
              </div>
            </button>
          }
        </div>
      </form>
    }
  </div>

  @if (actions && actions.length) {
    <div class="modal-footer">
      @for (action of actions; track action) {
        <button
          class="btn"
          id="alert-footer-action-{{action.type}}"
          [ngClass]="setAlertBtnActionStyle(action.type)"
          (click)="btnActionClickHandler(action.callback)"
          >
          {{ action.label }}
        </button>
      }
    </div>
  }
